import { useQuery } from "@tanstack/react-query";

const API = import.meta.env.VITE_API_BASE_URL;

function useDashboardDevices() {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => {
      const res = await fetch(`${API}dashboard`, { credentials: "include" });
      if (!res.ok) throw new Error("dashboard fetch failed");
      return res.json();
    },
    staleTime: 60_000,
    select: (data) =>
      Object.entries(data.devices ?? {}).map(([id, d]) => ({
        id: Number(id),
        hostname: d.device.hostname,
        connectcode: d.device.connectcode,
        label: d.device.display_name ?? d.device.hostname,
      })),
  });
}

export default function DeviceSelect({ value, onChange, className = "" }) {
  const { data: devices = [], isLoading } = useDashboardDevices();

  if (isLoading) {
    return <div className="text-sm text-gray-400">Loading devices…</div>;
  }
  if (devices.length === 0) {
    return <div className="text-sm text-gray-400">No devices connected</div>;
  }
  return (
    <select
      value={value}
      onChange={onChange}
      className={`w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500 bg-white ${className}`}
    >
      <option value="">— none —</option>
      {devices.map((d) => (
        <option key={d.id} value={d.id}>
          {d.label} ({d.connectcode})
        </option>
      ))}
    </select>
  );
}
